import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Feature, MembershipSchema } from '@tacliatech/types';
import { PermissionService } from '@web-frontend/shared/services/permissions';
import { SignatureComponent } from '../signature';
import { SignatureModal } from './signature-modal.types';
import { environment } from '@web-frontend/environments';

@Component({
  selector: 'roma-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrls: ['./signature-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignatureModalComponent implements OnInit {
  @ViewChild('signature')
  signatureRefComponent!: SignatureComponent;

  source!: string;
  signatureData!: string;
  signatureWidth = 413;

  featureRef = Feature;
  hasFeatureSeeLogo$ = this.permissionService.hasFeatureFn(
    Feature.Deal.SignDocuments
  );
  showDisclaimer = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SignatureModal.ModalParams,
    private dialogRef: MatDialogRef<
      SignatureModalComponent,
      SignatureModal.ModalParamsRes
    >,
    private cdRef: ChangeDetectorRef,
    private permissionService: PermissionService
  ) {}

  get params() {
    return this.data;
  }

  ngOnInit(): void {
    if (this.data.source) {
      this.source = this.data.source;
      this.draw();
    }

    this.resolveSignatureWidth();
  }

  submit() {
    const source = this.signatureRefComponent.signaturePad.toDataURL();

    this.dialogRef.close({ source });
  }

  close() {
    // @ts-ignore
    this.dialogRef.close({ source: null });
  }

  delete() {
    try {
      this.signatureRefComponent.signaturePad.clear();
      this.signatureRefComponent.resolveIsEmpty();
    } catch (err) {}
  }

  private draw() {
    this.cdRef.detectChanges();
  }

  private resolveSignatureWidth() {
    if (window.innerWidth <= 768) {
      this.signatureWidth = window.innerWidth - 65;
      this.draw();
    }
  }

  determineCopy(copy: string): string {
    if (environment.MembershipSchema === MembershipSchema.OneProPlan) {
      return `${copy}-new`;
    } else {
      return copy;
    }
  }
}
